export const updateInboundShipmentMini = /* GraphQL */ `
  mutation UpdateInboundShipment(
    $input: UpdateInboundShipmentInput!
    $condition: ModelInboundShipmentConditionInput
  ) {
    updateInboundShipment(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateInboundShipment = /* GraphQL */ `
  mutation UpdateInboundShipment(
    $input: UpdateInboundShipmentInput!
    $condition: ModelInboundShipmentConditionInput
  ) {
    updateInboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      poNumber
      lotNumber
      lotNumberOverride
      shipFrom
      carrierType
      carrierName
      lotType
      railCarNumber
      containerDrop
      containerNumber
      totalUOM
      advisedBy
      createDateTime
      scheduledDateTime
      notifyDateTime
      placedDateTime
      startDateTime
      endDateTime
      releaseDateTime
      stripeBillingDateTime
      daysOnDemurrageClock
      stepName
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      assignedTo
      workflowType
      unloadedBy
      reviewedBy
      secondaryReview
      verificationRequired
      stockImport
      returnShipment
      returnOutboundShipmentId
      returnReason
      hasException
      unsafeShipment
      unsafeShipmentNote
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      sealNumbers
      seals {
        items {
          id
          active
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          createdAt
          createdBy
          brokenAt
          brokenBy
          validated
          description
          updatedAt
          isScanned
          owner
        }
      }
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      accountName
      accountId
      account {
        id
        # owner
        groups
        active
        status
        externalId
        lotNumberPrefix
        businessName
        displayName
        defaultWeightUOM
        email
        phone
        # fax
        # website
        address {
          name
          street
          city
          state
          zipCode
          country
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
        }
        inboundInstructions
        inboundPhotos
        outboundCustomFields {
          id
          name
          type
          display
        }
        outboundInstructions
        inventoryCustomFields {
          id
          name
          type
          display
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        secondaryReview
        updatedAt
      }
      reloadYardId
      inventories {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          railCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          inventoryItems {
            items {
              id
              quantityOnHand
              quantityCommitted
              hasException
              isDamaged
              otherException
              otherExceptionNote
              status
              unloadedBy
              unloadedAt
              history {
                type
                date
                by
                text
              }
              areaId
              zoneId
              aisleId
              locationId
              location {
                id
                name
                type
                area {
                  name
                  prefix
                  areaType
                }
                zone {
                  name
                  prefix
                  accountId
                }
                aisle {
                  id
                  name
                  type
                  bays
                  levels
                  capacityUsed
                  length
                  width
                }
                bay
                level
                position
              }
              outboundShipmentId
              locationFullName
              latitude
              longitude
            }
          }
          notes {
            type
            date
            by
            text
            public
          }
          history {
            type
            date
            by
            text
          }
          productName
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          auditId
          reloadYardCommodityId
          customFields
          createdAt
          updatedAt
        }
        nextToken
      }
      invoiceId
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        zones {
          nextToken
        }
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        zoneType
        sortKey
        areaId
        createdAt
        updatedAt
      }
      isCollected
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      selectedCustomFields {
        id
        name
        type
        display
      }
      createdAt
      updatedAt
    }
  }
`;

export const createInboundShipmentId = /* GraphQL */ `
  mutation CreateInboundShipment(
    $input: CreateInboundShipmentInput!
    $condition: ModelInboundShipmentConditionInput
  ) {
    createInboundShipment(input: $input, condition: $condition) {
      id
    }
  }
`;

export const deleteInboundShipmentMini = /* GraphQL */ `
  mutation DeleteInboundShipment(
    $input: DeleteInboundShipmentInput!
    $condition: ModelInboundShipmentConditionInput
  ) {
    deleteInboundShipment(input: $input, condition: $condition) {
      id
    }
  }
`;
